<template>
  <div class="home">
    <!-- <v-row class="logo" justify="center" align="center">
      <v-col cols="12" class="text-center">
        <img src="@/assets/tely.png" alt="">
      </v-col>
    </v-row> -->
    <!-- <div class="symbols">
      <img src="@/assets/symbol.png" width="100%" alt="">
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'Home',
  created() {
    setTimeout(() => {
      this.$router.push('/signinadmin')
    }, 5000)
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  position: relative;
  overflow: hidden !important;
  overflow: -moz-hidden-unscrollable !important;
  background-color: #01DCFC;
  background-image: url('../../assets/background_splash.png');
  background-position: center;
}
.logo {
  min-height: 100vh;
}
.logo img{
  margin-bottom: 188px;
}
.symbols {
  position: absolute;
  right: 0px;
  bottom: -5px;
}
</style>
